import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const LOAN_TYPE_DEFAULTS = { loan_type: "pi", io_years_remaining: "5", io_indefinite: false };

export const loanTypeFromApi = (d = {}) => ({
  loan_type: d.loan_type || "pi",
  io_years_remaining: d.io_years_remaining != null ? String(d.io_years_remaining) : "5",
  io_indefinite: d.loan_type === "io" && d.io_years_remaining == null,
});

export const loanTypeToApi = (f) => ({
  loan_type: f.loan_type || "pi",
  io_years_remaining: f.loan_type === "io" && !f.io_indefinite ? (parseInt(f.io_years_remaining) || 0) : null,
});

export const LoanTypeFields = ({ value, onChange, testIdPrefix = "loan" }) => {
  const isIO = value.loan_type === "io";
  return (
    <div className="space-y-3" data-testid={`${testIdPrefix}-type-fields`}>
      <div className="space-y-2">
        <Label>Repayment Type</Label>
        <Select value={value.loan_type || "pi"} onValueChange={(v) => onChange({ loan_type: v })}>
          <SelectTrigger data-testid={`${testIdPrefix}-type-select`}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="pi" data-testid={`${testIdPrefix}-type-pi`}>Principal & Interest</SelectItem>
            <SelectItem value="io" data-testid={`${testIdPrefix}-type-io`}>Interest Only</SelectItem>
          </SelectContent>
        </Select>
        <p className="text-xs text-slate-500">
          {isIO ? "Repayments cover interest only, so the loan balance isn't paid down." : "Repayments pay down the loan balance over the loan term."}
        </p>
      </div>
      {isIO && (
        <div className="p-3 bg-slate-50 rounded-lg space-y-3">
          <div className="flex items-center justify-between">
            <Label htmlFor={`${testIdPrefix}-io-indefinite`} className="text-sm">Interest only indefinitely</Label>
            <Switch id={`${testIdPrefix}-io-indefinite`} checked={!!value.io_indefinite}
              onCheckedChange={(c) => onChange({ io_indefinite: c })} data-testid={`${testIdPrefix}-io-indefinite-switch`} />
          </div>
          {!value.io_indefinite && (
            <div className="space-y-1">
              <Label className="text-sm">Interest-only years remaining</Label>
              <Input type="number" min="0" value={value.io_years_remaining}
                onChange={(e) => onChange({ io_years_remaining: e.target.value })} data-testid={`${testIdPrefix}-io-years-input`} />
              <p className="text-xs text-slate-500">After this, the loan reverts to Principal & Interest over the rest of the term.</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
